const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,

  // apiKey: "AIzaSyBxu1mR_57mykygStFqPQdHVIJcZpC41FI",
  // authDomain: "watches-online-6f326.firebaseapp.com",
  // projectId: "watches-online-6f326",
  // storageBucket: "watches-online-6f326.appspot.com",
  // messagingSenderId: "901767403852",
  // appId: "1:901767403852:web:ea332cbb65ff1495a617e9",
};

export default firebaseConfig;
